import { render, staticRenderFns } from "./AssignRelationship.vue?vue&type=template&id=6f4fb20e&"
import script from "./AssignRelationship.vue?vue&type=script&lang=js&"
export * from "./AssignRelationship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports